export const getChatHeaderVisibility = (selected: boolean, minimized: boolean, dropdownOpen: boolean) => ({
  showMinimizedActions: minimized,
  showHeaderActions: selected && !minimized,
  showChatMenu: !minimized && dropdownOpen
});
